import { type FC } from 'react';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { RecentlyViewedItemsLazy } from 'dibs-recent-history/exports/RecentlyViewedItemsLazy';
import { useRecentlyViewedItemsContext } from 'dibs-recent-history/exports/useRecentlyViewedItemsContext';
import { MOBILE } from 'dibs-recent-history/exports/RecentlyViewedItemsProvider';

import {
    trackViewMoreClick,
    trackItemClick,
    trackItemImpression,
} from 'dibs-recent-history/exports/recentHistoryTracking';
import { trackModule, trackModuleLocation } from '../helpers/moduleLocationTracking';
import { trackInitialDisplay } from '../helpers/carouselTracking';
import { useCurrency } from 'dibs-buyer-layout/exports/useCurrency';
import { useHomePageContext } from '../HomePageContext';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

const ACTION_LABEL = 'recently viewed';
const TRACKING_TITLE = 'Recently Viewed';

export const HpSharedRecentlyViewedItems: FC<{
    moduleIndex: number;
    totalModules: number;
}> = ({ moduleIndex, totalModules }) => {
    const { currency } = useCurrency();
    const { isBot } = useHomePageContext();
    const { deviceType } = useRecentlyViewedItemsContext();
    const isMobile = deviceType === MOBILE;

    return (
        <>
            <RecentlyViewedItemsLazy
                hasBottomSeparator={!isMobile}
                authModalLoader={authModalLoader}
                actionLabel={ACTION_LABEL}
                trackViewMoreClick={trackingProps => {
                    trackViewMoreClick(trackingProps);
                    trackModule(TRACKING_TITLE);
                }}
                trackItemClick={trackingProps => {
                    trackItemClick({ ...trackingProps, variant: 'homepage' });
                    trackModuleLocation({
                        label: 'recently viewed module',
                        moduleIndex,
                        totalModules,
                    });
                    trackModule(TRACKING_TITLE);
                }}
                trackItemImpression={trackingProps => {
                    trackItemImpression({ ...trackingProps, variant: 'homepage' });
                }}
                onInitialDisplay={({ items }) => {
                    trackInitialDisplay({ itemsReturned: items.length, actionLabel: ACTION_LABEL });
                }}
                currency={currency}
                isBot={isBot}
            />
            {isMobile && (
                <div
                    className={classnames(
                        dibsCss.borderB,
                        dibsCss.borderBSolid,
                        dibsCss.borderBDolphin
                    )}
                />
            )}
        </>
    );
};
